import { render, staticRenderFns } from "./CovidNetworkFilter.vue?vue&type=template&id=52d1e51e&"
import script from "./CovidNetworkFilter.vue?vue&type=script&lang=js&"
export * from "./CovidNetworkFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports